import React from 'react';
import ReactDOM from 'react-dom/client';
import './style/index.css';
import './style/components/swiper-dev.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import Context from './context/context';
import Configuration from './context/config';
import Action from './context/action';
import Data from './context/data';
import Switch from './context/switch';
import Settings from './context/settings';
import Authentication from './context/auth';
import Scene from './context/scenes';
import Collect from './context/collect';
import InitData from './context/initial';

import './translator/i18next';

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import References from './context/ref';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(() => {
        console.log('✅ Service Worker registered:');
      })
      .catch(() => {
        console.log('❌ Service Worker registration failed:');
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
      <Configuration>
        <Authentication>
          <Settings>
            <Switch>
              <Context>
                <Data>
                  <InitData>
                    <Action>
                      <Collect>
                        <Scene>
                          <ToastContainer/>
                          <References>
                            <App />
                          </References>
                        </Scene>
                      </Collect>
                    </Action>
                  </InitData>
                </Data>
              </Context>
            </Switch>
          </Settings>
        </Authentication>
      </Configuration>
    </BrowserRouter>
);